import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import Plural from 'components/utils/Formatters/Plural'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import React, { PropsWithChildren, ReactNode } from 'react'
import Expander from 'components/utils/Expander'
import styled from 'styled-components'
import { rem } from 'polished'

const NameText = styled(BodyText)`
  transition: color 300ms;
`

const UpgradeNameText = styled(BodyText)`
  transform: translateY(${rem(-16)});
  transition: transform 300ms;

  &.visible {
    transform: translateY(0);
  }
`

type Props = {
  /**
   * positive integer
   */
  packageNumber?: number
  tagLineLabel?: ReactNode
  stayPayRateTier?: App.StayPayTier
  selectedTargetUpgradePackage?: App.Package
  targetUpgradePackage?: App.Package
} & ({
  roomPackage?: App.HotelPackage
  promotion?: undefined
  rateName?: undefined
} | {
  roomPackage?: undefined
  promotion?: App.BedbankPromotion
  rateName?: undefined
} | {
  roomPackage?: undefined
  promotion?: undefined
  rateName: string
})

function AccommodationPackageTileDetails(props: PropsWithChildren<Props>) {
  const {
    children,
    packageNumber,
    tagLineLabel,
    roomPackage,
    promotion,
    rateName,
    stayPayRateTier,
    selectedTargetUpgradePackage,
    targetUpgradePackage,
  } = props

  const name = roomPackage?.name ?? promotion?.name ?? rateName
  const targetUpgradeName = selectedTargetUpgradePackage?.name
  const displayTier = useAppSelector(getLoyaltyDisplayTier)

  return <div>
    <VerticalSpacer gap={4}>
      <VerticalSpacer gap={8}>
        {!!packageNumber && <Caption variant="large">
          Option {packageNumber}
          {!!targetUpgradeName && <> | <b>{getLoyaltyTierDisplayName(displayTier)} member upgrade</b></>}
        </Caption>}
        {!!tagLineLabel && <LabelGroup>{tagLineLabel}</LabelGroup>}
      </VerticalSpacer>
      <Expander expanded={!!selectedTargetUpgradePackage} contentTransition="delayed">
        <UpgradeNameText variant="large" weight="bold" className={selectedTargetUpgradePackage ? 'visible' : undefined}>
          {selectedTargetUpgradePackage?.name ?? targetUpgradePackage?.name}
        </UpgradeNameText>
      </Expander>
      {!!name && <NameText
        variant="large"
        weight="bold"
        colour={selectedTargetUpgradePackage ? 'neutral-four' : 'neutral-one'}
        strikeThrough={!!selectedTargetUpgradePackage}
      >
        {name}
        {stayPayRateTier && <>, <Plural singular="night free" count={stayPayRateTier.freeNights} withCount /></>}
      </NameText>}
    </VerticalSpacer>
    {children}
  </div>
}

export default AccommodationPackageTileDetails
